module.exports = __webpack_public_path__ + "static/img/格力风不吹人空调.c7e9abd7.png";